import { render } from "./PpcBudgetAllocation.vue?vue&type=template&id=74c3129a&scoped=true"
import script from "./PpcBudgetAllocation.vue?vue&type=script&lang=js"
export * from "./PpcBudgetAllocation.vue?vue&type=script&lang=js"

import "./PpcBudgetAllocation.vue?vue&type=style&index=0&id=74c3129a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c3129a"]])

export default __exports__